import { Dispatch, useEffect } from 'react';
import PaginationState from '../state/pagination-state';
import PaginationAction from '../state/pagination-action';

const usePagination = <T>(
  data: T[],
  pageSize: number,
  pagination: PaginationState,
  dispatch: Dispatch<PaginationAction>,
): T[] => {
  useEffect(() => {
    dispatch({
      type: 'reset-pagination',
      total: data.length,
      pageSize,
    });
  }, [data.length]);

  const max = pagination.currentPage * pagination.pageSize;
  return data.slice(0, max);
};

export default usePagination;
